var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "manage-tags-modal" },
    [
      _c(
        "base-modal-ex",
        {
          attrs: {
            active: _vm.isActive,
            "animation-in": _vm.animationIn,
            "animation-out": _vm.animationOut,
            "animation-duration": _vm.animationDuration,
            "can-cancel": false,
            "min-width": "10vw",
            "max-width": "10vw",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isActive = $event
            },
          },
        },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c("p", { staticClass: "modal-card-title" }, [
              _vm._v("Manage Tags"),
            ]),
          ]),
          _c("section", { staticClass: "modal-card-body" }, [
            _c("div", { staticClass: "columns" }, [
              _c("div", { staticClass: "column is-full" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label is-required-label" }, [
                    _vm._v("Tag Name"),
                  ]),
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newTag.name,
                          expression: "newTag.name",
                        },
                      ],
                      staticClass: "input",
                      class: { "is-danger": !_vm.isTagNameValid },
                      attrs: {
                        type: "text",
                        placeholder: "Add Name",
                        maxlength: "30",
                      },
                      domProps: { value: _vm.newTag.name },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.newTag, "name", $event.target.value)
                        },
                      },
                    }),
                    _c("div", { staticClass: "help is-secondary" }, [
                      _vm._v(" " + _vm._s(_vm.newTag.name.length) + "/30 "),
                    ]),
                    !_vm.isTagNameValid
                      ? _c("div", { staticClass: "tags" }, [
                          _c("span", { staticClass: "tag is-danger" }, [
                            _vm._v(
                              " Name already in use, choose a different name "
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "columns is-vcentered is-multiline" }, [
              _c("div", { staticClass: "column is-3" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label is-required-label" }, [
                    _vm._v("Add Short Tag"),
                  ]),
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newTag.shortTag,
                          expression: "newTag.shortTag",
                        },
                      ],
                      staticClass: "input",
                      class: { "is-danger": !_vm.isShortTagValid },
                      attrs: {
                        type: "text",
                        placeholder: "ST",
                        maxlength: "5",
                      },
                      domProps: { value: _vm.newTag.shortTag },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.newTag,
                              "shortTag",
                              $event.target.value
                            )
                          },
                          function ($event) {
                            _vm.newTag.shortTag =
                              $event.target.value.toUpperCase()
                          },
                        ],
                      },
                    }),
                    _c("div", { staticClass: "help is-secondary" }, [
                      _vm._v(" " + _vm._s(_vm.newTag.shortTag.length) + "/5 "),
                    ]),
                    !_vm.isShortTagValid
                      ? _c("div", { staticClass: "tags" }, [
                          _c("span", { staticClass: "tag is-danger" }, [
                            _vm._v(
                              " Short Tag already in use, choose a different short tag "
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "column is-7 has-text-centered" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Select Colour"),
                  ]),
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newTag.color,
                          expression: "newTag.color",
                        },
                      ],
                      staticClass: "color-circle",
                      attrs: { type: "color" },
                      domProps: { value: _vm.newTag.color },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.newTag, "color", $event.target.value)
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "column is-2" }, [
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "control pt-5" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "button is-fullwidth tooltip bordered has-text-weight-bold",
                        class: { "is-static": !_vm.canAddTag },
                        attrs: {
                          "data-tooltip":
                            _vm.editingTagIndex === null
                              ? "Add Tag"
                              : "Update Tag",
                          disabled: !_vm.canAddTag,
                        },
                        on: { click: _vm.addTag },
                      },
                      [
                        _c("span", { staticClass: "icon has-text-primary" }, [
                          _vm.editingTagIndex === null
                            ? _c("i", { staticClass: "mdi mdi-plus mdi-28px" })
                            : _c("i", {
                                staticClass: "mdi mdi-content-save mdi-28px",
                              }),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "content mt-5" },
              _vm._l(
                _vm.localTags.filter((tag) => tag.isDeleted !== true),
                function (tag, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "box tag-item" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "tag-short",
                          style: {
                            backgroundColor: tag.colorHex,
                            color: _vm.getTextColor(tag.colorHex),
                          },
                        },
                        [_vm._v(_vm._s(tag.shortTag))]
                      ),
                      _c("span", { staticClass: "tag-name" }, [
                        _vm._v(_vm._s(tag.tagName)),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "buttons is-right",
                          staticStyle: { "flex-wrap": "nowrap" },
                        },
                        [
                          _vm.editingTagIndex === index
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "button is-ghost is-small tooltip p-0 has-text-danger is-clickable mr-2",
                                  attrs: { "data-tooltip": "Cancel Edit" },
                                  on: { click: _vm.cancelEditTag },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "material-symbols-outlined",
                                    },
                                    [_vm._v("close")]
                                  ),
                                ]
                              )
                            : _c(
                                "button",
                                {
                                  staticClass:
                                    "button is-ghost is-small tooltip p-0 has-text-primary is-clickable mr-2",
                                  attrs: { "data-tooltip": "Edit" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.editTag(tag)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "material-symbols-outlined",
                                    },
                                    [_vm._v("edit")]
                                  ),
                                ]
                              ),
                          _c(
                            "button",
                            {
                              staticClass:
                                "button is-ghost is-small tooltip px-0 mr-1 has-text-grey-lighter",
                              staticStyle: {
                                border: "none",
                                height: "auto",
                                background: "transparent",
                              },
                              attrs: { "data-tooltip": "Delete" },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteTag(tag.tagID)
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "material-symbols-rounded",
                                  on: {
                                    mouseenter: function ($event) {
                                      return $event.target.classList.add(
                                        "has-text-danger"
                                      )
                                    },
                                    mouseleave: function ($event) {
                                      return $event.target.classList.remove(
                                        "has-text-danger"
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" delete ")]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                }
              ),
              0
            ),
          ]),
          _c(
            "footer",
            {
              staticClass:
                "modal-card-foot is-flex is-justify-content-flex-end",
            },
            [
              _c("div", { staticClass: "buttons" }, [
                _c(
                  "button",
                  {
                    staticClass: "button tooltip",
                    attrs: { "data-tooltip": "Close" },
                    on: { click: _vm.saveTags },
                  },
                  [
                    _c("span", { staticClass: "icon" }, [
                      _c("i", { staticClass: "mdi mdi-close mdi-20px" }),
                    ]),
                    _c("span", [_vm._v("Close")]),
                  ]
                ),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }